import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/Footer.css';
import { FaWhatsapp, FaFacebookF, FaInstagram } from 'react-icons/fa';
import logo from '../assets/images/logo.png';

import GalleryImage1 from '../assets/images/galary11.png';
import GalleryImage3 from '../assets/images/galary19.png';
import GalleryImage4 from '../assets/images/galary4.png';
import GalleryImage14 from '../assets/images/galary14.png';
import GalleryImage15 from '../assets/images/galary15.jpeg';
import GalleryImage16 from '../assets/images/galary16.png';
import GalleryImage17 from '../assets/images/galary17.png';
import GalleryImage18 from '../assets/images/galary18.png';


const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Logo and Description Section */}
                <div className="footer-logo">
                    <div className="logo">
                        <img src={logo} alt="HELLO CHARGE Logo" style={{ height: '70px' }} />
                    </div>
                    <p>{t('footer.description')}</p>
                    <div className="social-icons">
                        <a href="https://wa.me/yournumber" aria-label="WhatsApp">
                            <FaWhatsapp className="social-icon" />
                        </a>
                        <a href="https://www.facebook.com/profile.php?id=61576850656324" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                            <FaFacebookF className="social-icon" />
                        </a>
                        <a href="https://www.instagram.com/hello.charge.resturant/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                            <FaInstagram className="social-icon" />
                        </a>
                    </div>
                </div>

                {/* Useful Links Section */}
                <div className="footer-links">
                    <h2>{t('footer.useful_links')}</h2>
                    <ul>
                        <li><a href="/">{t('footer.links.home')}</a></li>
                        <li><a href="/#speisekarte">{t('footer.links.menu')}</a></li>
                        <li><a href="/#ueberuns">{t('footer.links.about')}</a></li>
                        <li><a href="/#ReservationForm">{t('navbar.TableReservation')}</a></li>
                    </ul>
                </div>

                {/* Contact Section */}
                <div id="kontakt" className="footer-contact">
                    <h2>{t('footer.contact')}</h2>
                    <p>{t('footer.address')}</p>
                    <p>{t('footer.phone')}</p>
                    <p>{t('footer.email')}</p>
                    <div className="opening-hours">
                        <p>{t('footer.hours.weekdays')}</p>
                        <p>{t('footer.hours.weekends')}</p>
                    </div>
                </div>
            </div>

            <div id="galerie" className="footer-gallery">
                <h2>{t('footer.gallery')}</h2>
                <div className="gallery-grid">
                    <img src={GalleryImage1} alt={t('footer.gallery_alt.0')} />
                    <img src={GalleryImage18} alt={t('footer.gallery_alt.1')} />
                    <img src={GalleryImage3} alt={t('footer.gallery_alt.2')} />
                    <img src={GalleryImage4} alt={t('footer.gallery_alt.3')} />
                    <img src={GalleryImage14} alt={t('footer.gallery_alt.3')} />
                    <img src={GalleryImage15} alt={t('footer.gallery_alt.3')} />
                    <img src={GalleryImage16} alt={t('footer.gallery_alt.3')} />
                    <img src={GalleryImage17} alt={t('footer.gallery_alt.3')} />
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="footer-bottom">
                <hr className="footer-divider" />
                <div className="footer-bottom-content">
                    <p>© 2025 HELLO CHARGE {t('footer.powered_by')} <a href="https://evo-era.com" target="_blank" rel="noopener noreferrer">EVOERA</a></p>
                    <div className="footer-legal">
                        <a href="/impressum">{t('footer.legal.imprint')}</a>
                        <span> | </span>
                        <a href="/datenschutz">{t('footer.legal.privacy')}</a>
                        <span> | </span>
                        <a href="/agb">AGB</a>


                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
